import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import UserProfileModal from './UserProfileModal';
import { AdminContextSwitcher } from './AdminContextSwitcher';
import { useAvatar } from '../../hooks/useAvatar';
import { getDisplayName } from '../../utils/nameUtils';
import { AGENT_PLATFORM_BASE } from '../../constants/agentPlatformRoutes';

export const AgentPlatformNavbar: React.FC = () => {
  const { user, signOut } = useAuth();
  const { avatarUrl } = useAvatar({
    userId: user?.id,
    avatarBase64: user?.avatarBase64,
  });
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [isUserProfileModalOpen, setIsUserProfileModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut();
    navigate('/login');
  };

  return (
    <>
      <nav className="w-full bg-[#363130] text-white px-6 py-3 flex items-center justify-between shadow">
        <div className="flex items-center gap-4 min-w-0">
          <Link to={AGENT_PLATFORM_BASE} className="flex items-center gap-2 shrink-0">
            <img src="/know-logo.png" alt="Logo" className="h-8 w-auto" />
            <span className="font-bold text-lg tracking-wide hidden sm:inline">Plataforma Agêntica</span>
          </Link>
          <AdminContextSwitcher active="agents" className="ml-4" />
        </div>
        <div className="flex items-center gap-4 shrink-0">
          <Link to="/dashboard" className="text-sm hover:text-red-200">
            Voltar para Aplicação
          </Link>
          <div className="relative">
            <button
              type="button"
              onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
              className="flex items-center gap-2 hover:text-red-200"
            >
              {avatarUrl ? (
                <img src={avatarUrl} alt="Avatar" className="h-8 w-8 rounded-full" />
              ) : (
                <div className="h-8 w-8 rounded-full bg-stone-300 flex items-center justify-center">
                  <span className="text-stone-800 text-sm font-medium">
                    {(user?.name?.[0] ?? 'U').toUpperCase()}
                  </span>
                </div>
              )}
              <span className="hidden md:inline">{getDisplayName(user?.name)}</span>
            </button>

            {isProfileMenuOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 text-gray-700 z-50">
                <button
                  type="button"
                  onClick={() => {
                    setIsProfileMenuOpen(false);
                    setIsUserProfileModalOpen(true);
                  }}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                >
                  Seu Perfil
                </button>
                <button
                  type="button"
                  onClick={handleSignOut}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                >
                  Sair
                </button>
              </div>
            )}
          </div>
        </div>
      </nav>

      <UserProfileModal
        isOpen={isUserProfileModalOpen}
        onClose={() => setIsUserProfileModalOpen(false)}
      />
    </>
  );
};
